import React from 'react';
import { Box, Grid2 } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CartLoader from '../../../Helper/Loaders/CartLoader';
import BaseChart from './BaseChart';

const PreviewChart = ({
    isLoading,
    chartID = "chartID",
    binarySignalsData,
    batteryInfo = {},
    selectedEntity = null,
}) => {

    const { t } = useTranslation()

    if (isLoading) {
        return (
            <Box sx={{ height: 525, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CartLoader />
            </Box>
        );
    }

    return (
        <Box sx={{ height: '500px', overflow: 'hidden', width: '100%' }}>
            <Box sx={{ height: '100%', overflowY: 'auto', overflowX: 'hidden', width: '100%' }}>
                <Grid2 container flexDirection={'column'} gap={1.5} py={2} flexWrap={'nowrap'} sx={{height: '100%'}}>
                    {(Object.values(binarySignalsData) ?? []).map(signalData => {
                        return <BaseChart
                            key={Math.random()}
                            chartId={`binary-signal-chart-${signalData.title}`}
                            title={signalData.title}
                            segments={signalData.segments}
                            colors={signalData.colors}
                            batteryInfo={batteryInfo}
                            selectedEntity={selectedEntity}
                        />
                    })}
                </Grid2>
            </Box>
        </Box>
    );
};

export default PreviewChart;
